import { Injectable } from '@angular/core';
import { UploadProviderService } from '@shared/services/http/http-provider.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private httpProvider: UploadProviderService,
              private httpClient: HttpClient) { }

  public generateUploadPresignURL(body: any, status: any) {
    return this.httpProvider
               .sendPostRequest('/get/presigned/upload', body, new HttpHeaders, new HttpParams().set('status', status))
               .pipe( map( res => res['body'] ) );
  }
  public getPresignURL(srid:any , documentID:any) {
    return this.httpProvider.sendGetRequest(`/get/presigned/file/${srid}`, new HttpHeaders, new HttpParams().set('documentID',documentID))
  }
  public getUploadedFiles(sr_uuid: any) {
    return this.httpProvider
               .sendGetRequest(`/service-request/${sr_uuid}`,
                                new HttpHeaders,
                                new HttpParams());
  }
  public deleteFiles(srid: string , filename: string) {
    return this.httpProvider
        .sendDeleteRequest(
            `/service-request/${srid}/${filename}`,
            new HttpHeaders,
            new HttpParams());
  }
  public sendSubmittedFiles(srid: any, documentIDs: any) {
    return this.httpProvider
               .sendPostRequest(`/register/document/${srid}`,{}, new HttpHeaders, new HttpParams().set('documents',documentIDs))
  }
  public getUploadedFilesNew(id: string) {
    return this.httpProvider.sendGetRequest(`/service-request/${id}`, new HttpHeaders, new HttpParams())
  }
  public uploadFile(sr_id: string, file: File) {
    const formData: FormData = new FormData() ;
    formData.append('file', file, file.name);
    return this.httpProvider.sendPostRequest(
        `/service-request/${sr_id}`,
        formData,
        new HttpHeaders,
        new HttpParams());
  }
  public uploadFilePresigned(url: string, file: File) {
    const headers = new HttpHeaders({SkipInterceptor: ''})
    const requestOptions = {
      headers: headers,
      observe: 'response' as 'body'
    };
    return this.httpClient.put(url, file, requestOptions).pipe(map(res => res['body']));
  }
  public viewUploadedFiles(srid: any, fileName: any, type: string) {
    if (type === 'download') {
       return this.httpProvider
                  .sendGetRequest(`/service-request/${srid}/${fileName}?access_type=download`,
                      new HttpHeaders,
                      new HttpParams());
     } else if ( type === 'view') {
       return this.httpProvider.sendGetRequest(`/service-request/${srid}/${fileName}?access_type=view`, new HttpHeaders, new HttpParams());
     }
     // return this.httpProvider.sendGetRequest(`/service-request/${srid}/${fileName}`, new HttpHeaders, new HttpParams())
   }
  public downloadFilesNew(id: string, filename: string) {
    let headers = new HttpHeaders()
    headers = headers.append('accept', 'application/pdf');
    return this.httpProvider.sendGetRequest(`/service-request/${id}/${filename}`, headers, new HttpParams());
  }

}
